import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

const urlListPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const inscribirUrlListarCarrera = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const devuelNumNivelesCarrera = ApiUrl + "numnivelcarrperiodcostomatri" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const ingresarValoresMatriPeriodCarrUrl = ApiUrl + "ingresarmatriculasperiodcarr" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

const carrerasUrl = inscribirUrlListarCarrera;
let listaauxiliar = [];
const itemsPerPage = 10;
export default class horasPracticasPreprof extends Component {

    constructor(props) {
        super(props)
        this.inputRefs = {};
        this.state = {
            carrera: [],
            estado: '',

            //nuevas variables
            numnivelescarr: '',
            listaperiodos: [],
            listaniveles: [],
        }
        this.handleChange = this.handleChange.bind(this);

    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });
    }


    handleChangeDevolverIdCarrera = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ listaniveles: [] });

        //devuelve los niveles de  una carrera y los datos registrados por cada nivel
        axios
            .post(devuelNumNivelesCarrera, {
                idCarreraf: this.state.idCarrera,
                periodoIdf: this.state.idPeriodoSelect,
            })
            .then(response => {
                const listaniveles1 = response.data.data;
                this.setState({ listaniveles: listaniveles1 });
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        axios.get(carrerasUrl)
            .then(res => {
                const carrera = res.data;
                this.setState({ carrera });
            })

        axios
            .get(urlListPeriodos)
            .then(response => {
                const listaperiodos = response.data.data;
                const cant = listaperiodos.length;
                if (cant != 0) {
                    this.setState({ listaperiodos });
                }
            })
    }

    registrarValoresCostoPeriodo = async (e) => {
        let materiasselect = this.state.listaniveles.map(nivel => {
            const idnivel = nivel.codnivel;
            const valorCM = this.inputRefs[`${idnivel}_matriculaord`]?.value || 0;
            const valorCMEXT = this.inputRefs[`${idnivel}_matriculaextra`]?.value || 0;
            const fechMEXT = this.inputRefs[`${idnivel}_fechamatriextr`]?.value || "";
            const valorCDPRACTLAB = this.inputRefs[`${idnivel}_practlab`]?.value || 0;
            const valorCDPRACTSERVCOMUN = this.inputRefs[`${idnivel}_practservicomun`]?.value || 0;

            return {
                idnivelf: idnivel,
                costomatri: valorCM,
                costomatriext: valorCMEXT,
                fechamatriextr: fechMEXT,
                costoderechplab: valorCDPRACTLAB,
                costoderechpservc: valorCDPRACTSERVCOMUN,
            };
        });

        try {
            const response = await axios.post(ingresarValoresMatriPeriodCarrUrl, {
                periodoactualef: this.state.idPeriodoSelect,
                listPeriodPrac: materiasselect,
                idCarreraf: this.state.idCarrera,
            });

            if (response.data.success === true) {
                swal({
                    text: "Datos ingresados exitosamente",
                    icon: "success",
                    button: "Aceptar",
                });
                const res2 = await axios.post(devuelNumNivelesCarrera, {
                    idCarreraf: this.state.idCarrera,
                    periodoIdf: this.state.idPeriodoSelect,
                });
                this.setState({ listaniveles: res2.data.data });
            } else {
                swal({
                    text: "Datos no registrados",
                    icon: "error",
                    button: "Aceptar",
                });
            }
        } catch (error) {
            this.setState({ estado: "Error No se pudo conectar con el servidor" });
            swal({
                text: "Datos no registrados",
                icon: "error",
                button: "Aceptar",
            });
        }
    };

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas d-flex align-items-center">
                        <i className="fa fa-dollar-sign bounce-custom me-2"></i>
                        <b className="mb-0 fw-semibold">Costos por Período</b>
                    </div>

                    <div className="p-3 rounded-3">
                        <div className="row g-3">
                            <div className="col-12 col-md-6 col-xl-6">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-calendar me-1"></i> Período:
                                </label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idPeriodoSelect"
                                    id="idPeriodoSelect"
                                    value={this.state.value}
                                    onChange={this.handleChange}
                                >
                                    <option value="undefined">Seleccione el período</option>
                                    {this.state.listaperiodos.map(periodo => (
                                        <option
                                            key={periodo.id_periodo_academico}
                                            value={periodo.id_periodo_academico}
                                        >
                                            {periodo.descripcion_periodo_academico}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-12 col-md-6 col-xl-6">
                                <label className="form-label text-azul small">Carrera:</label>
                                <select
                                    className="form-select form-select-sm"
                                    id="idCarrera"
                                    name="idCarrera"
                                    value={this.state.value}
                                    onChange={this.handleChangeDevolverIdCarrera}
                                >
                                    <option value="undefined">Seleccione una carrera</option>
                                    {this.state.carrera.map(person => (
                                        <option key={person.id_carrera} value={person.id_carrera}>
                                            {person.descripcion_carrera}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="table-responsive mt-4">
                            <table className="table table-sm table-hover align-middle">
                                <thead className="small text-center table-light">
                                    <tr className="align-middle">
                                        <th className="text-start text-azul">Nivel</th>
                                        <th className="text-start text-azul">Matrículas Ordinarias</th>
                                        <th className="text-start text-azul">Matrículas Extraordinarias</th>
                                        <th className="text-start text-azul">Fecha Matr. Extra</th>
                                        <th className="text-start text-azul">Prácticas Laborales</th>
                                        <th className="text-start text-azul">Servicio Comunitario</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.listaniveles.map(consola => (
                                        <tr key={consola.codnivel}>
                                            <td className="text-azul small">{consola.codnivel}</td>
                                            <td>
                                                <input
                                                    type="text"
                                                    ref={el => (this.inputRefs[`${consola.codnivel}_matriculaord`] = el)}
                                                    className="form-control form-control-sm"
                                                    defaultValue={consola.valor_matriord}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    ref={el => (this.inputRefs[`${consola.codnivel}_matriculaextra`] = el)}
                                                    className="form-control form-control-sm"
                                                    defaultValue={consola.valor_matriext}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="date"
                                                    ref={el => (this.inputRefs[`${consola.codnivel}_fechamatriextr`] = el)}
                                                    className="form-control form-control-sm"
                                                    defaultValue={consola.fechamatriextr}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    ref={el => (this.inputRefs[`${consola.codnivel}_practlab`] = el)}
                                                    className="form-control form-control-sm"
                                                    defaultValue={consola.valor_practlab}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    ref={el => (this.inputRefs[`${consola.codnivel}_practservicomun`] = el)}
                                                    className="form-control form-control-sm"
                                                    defaultValue={consola.valor_practservicomun}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="d-flex justify-content-center mt-4">
                            <button
                                id="agregar"
                                type="button"
                                className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                style={{ borderRadius: "8px", fontSize: "0.85rem" }}
                                onClick={() => this.registrarValoresCostoPeriodo()}
                            >
                                <i className="fas fa-plus me-1"></i>Registrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

